import type { TAsrExecutionStage } from 'app/API/custom/asr-execution/types';

export const getExecutionStageDurationMs = (
  stages: TAsrExecutionStage[],
  fromStage: string,
  toStage: string,
): number | undefined => {
  const from = stages.find((stage) => stage.name === fromStage);
  const to = [...stages].reverse().find((stage) => stage.name === toStage);
  if (!from || !to) {
    return undefined;
  }
  const duration = new Date(to.at).getTime() - new Date(from.at).getTime();
  return Number.isNaN(duration) || duration < 0 ? undefined : duration;
};
